{
  "blocks": [
    {
      "id": "med-medroxyprogesterone",
      "kind": "medication",
      "tags": ["medications", "her", "during-cycle", "ivf"],
      "title": "Provera",
      "subtitle": "Medroxyprogesterone - oral progestin for cycle scheduling and PPOS",
      "body": {
        "genericName": "Medroxyprogesterone acetate",
        "drugClass": "Progestin (synthetic progesterone)",
        "purpose": "Provera is an oral progestin that mimics natural progesterone. In fertility care it is used in two main ways. First, for cycle scheduling: a short course builds up the uterine lining, and when you stop, the drop in progestin triggers a withdrawal bleed, giving your clinic a known cycle start date before stimulation. Second, in PPOS (progestin-primed ovarian stimulation) protocols it is taken alongside stimulation injections, where it suppresses the pituitary and prevents a premature LH surge, working as an oral alternative to GnRH antagonist injections.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "Cycle scheduling / withdrawal bleed: 5 to 10 mg by mouth once daily for 5 to 10 days; a bleed usually starts 3 to 7 days after the last tablet. PPOS protocols: typically 10 mg by mouth once daily, started early in stimulation and continued until the trigger injection. Always follow the exact dose and schedule your clinic gives you.",
        "howToTake": "Step 1: Confirm the plan - Check with your clinic which use applies to you (a short scheduling course to bring on a bleed, or daily dosing through PPOS stimulation) and the exact start day. | Step 2: Take the tablet - Swallow one tablet once daily at the same time each day, with or without food. A daily alarm helps you stay consistent. | Step 3: Scheduling course - If you are taking it to trigger a bleed, finish the full course; a withdrawal bleed usually starts 3 to 7 days after the last tablet. Call your clinic on day 1 of bleeding. | Step 4: PPOS course - If you are on a PPOS protocol, keep taking it daily alongside your stimulation injections and attend all scans; do not stop until your clinic tells you. | ⚠ Missed dose - Take it as soon as you remember the same day. If it is the next day, skip it and continue your normal schedule; do not double up. | ⚠ When to call - Contact your clinic promptly for calf pain or swelling, chest pain, sudden breathlessness, severe headache, vision changes, heavy bleeding, severe pelvic pain, or yellowing of the skin or eyes.",
        "sideEffects": [
          "Spotting or breakthrough bleeding",
          "Bloating and fluid retention",
          "Breast tenderness",
          "Mood changes",
          "Headache",
          "Nausea",
          "Fatigue or drowsiness",
          "Small increased risk of blood clots (uncommon)"
        ],
        "storage": "Store at room temperature, around 20 to 25°C (68 to 77°F). Keep in the original packaging, away from excess heat and moisture, and out of reach of children.",
        "forWhom": "her",
        "aliases": [
          "Provera",
          "Medroxyprogesterone",
          "Medroxyprogesterone acetate",
          "MPA"
        ],
        "availability": [
          {
            "name": "Provera",
            "manufacturer": "Pfizer",
            "countries": ["US", "GB", "EU", "CA", "AU", "IE", "ZA"]
          },
          {
            "name": "Medroxyprogesterone (generic)",
            "countries": ["US", "GB", "EU", "CA", "AU"]
          }
        ],
        "frBody": {
          "genericName": "Acétate de médroxyprogestérone",
          "drugClass": "Progestatif (progestérone de synthèse)",
          "purpose": "Provera est un progestatif oral qui imite la progestérone naturelle. En parcours de fertilité, il sert surtout à deux choses. D'abord, pour planifier le cycle : une courte cure épaissit la muqueuse utérine, et à l'arrêt, la chute du progestatif déclenche un saignement de privation, donnant au centre une date de début de cycle connue avant la stimulation. Ensuite, dans les protocoles PPOS (stimulation amorcée par un progestatif), il se prend avec les injections de stimulation : il freine l'hypophyse et empêche un pic prématuré de LH, en alternative orale aux antagonistes de la GnRH.",
          "dosageRanges": "Planification / saignement de privation : 5 à 10 mg par voie orale une fois par jour pendant 5 à 10 jours ; le saignement survient généralement 3 à 7 jours après le dernier comprimé. Protocoles PPOS : habituellement 10 mg par voie orale une fois par jour, débutés tôt dans la stimulation et poursuivis jusqu'au déclenchement. Suivez toujours la dose et le calendrier exacts de votre centre.",
          "howToTake": "Étape 1 : Confirmer le plan - Vérifiez avec votre centre l'usage qui vous concerne (courte cure pour provoquer un saignement, ou prise quotidienne pendant la stimulation PPOS) et le jour de début exact. | Étape 2 : Prendre le comprimé - Avalez un comprimé une fois par jour, à la même heure, avec ou sans nourriture. Une alarme quotidienne aide à rester régulière. | Étape 3 : Cure de planification - Si vous le prenez pour provoquer un saignement, terminez toute la cure ; le saignement survient 3 à 7 jours après le dernier comprimé. Appelez votre centre le 1er jour des règles. | Étape 4 : Cure PPOS - Sous protocole PPOS, continuez chaque jour avec vos injections et assistez à tous les contrôles ; n'arrêtez pas avant l'accord de votre centre. | ⚠ Dose oubliée - Prenez-la dès que vous y pensez le jour même. Le lendemain, sautez-la et reprenez le rythme habituel ; ne doublez pas. | ⚠ Quand appeler - Contactez rapidement votre centre en cas de douleur ou gonflement du mollet, douleur thoracique, essoufflement soudain, maux de tête sévères, troubles de la vision, saignements abondants, douleurs pelviennes sévères, ou jaunissement de la peau ou des yeux.",
          "sideEffects": [
            "Pertes ou saignements entre les règles",
            "Ballonnements et rétention d'eau",
            "Sensibilité des seins",
            "Changements d'humeur",
            "Maux de tête",
            "Nausées",
            "Fatigue ou somnolence",
            "Léger risque accru de caillots sanguins (peu fréquent)"
          ],
          "storage": "Conserver à température ambiante, autour de 20 à 25°C (68 à 77°F). Garder dans l'emballage d'origine, à l'abri de la chaleur et de l'humidité, et hors de portée des enfants."
        }
      }
    },
    {
      "id": "med-combined-oral-contraceptive",
      "kind": "medication",
      "tags": ["medications", "her", "during-cycle", "ivf"],
      "title": "Birth control pill",
      "subtitle": "Combined oral contraceptive - used to schedule and prime an IVF cycle",
      "body": {
        "genericName": "Combined oral contraceptive (ethinylestradiol + progestin)",
        "drugClass": "Combined hormonal contraceptive (estrogen + progestin)",
        "purpose": "The combined birth control pill contains an estrogen (usually ethinylestradiol) and a progestin. It is not a fertility drug itself, but in IVF it is often used as pretreatment before an antagonist stimulation cycle. By temporarily quieting the ovaries' own hormone signals, it lets the clinic plan exactly when stimulation will start, which helps with booking egg retrieval and lab scheduling. It can also help the early follicles grow more evenly so they respond more uniformly once stimulation begins. This is a class of medicines rather than a single brand, so your clinic may prescribe any of several widely available combined pills.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "Typically one active (hormone-containing) tablet by mouth once daily for about 2 to 4 weeks before starting stimulation, then stopped on the day your clinic specifies (often around 3 to 5 days before stimulation injections begin). The exact pill, duration, and stop day are set by your clinic; follow their instructions rather than the standard contraception schedule on the pack.",
        "howToTake": "Step 1: Confirm the plan - Your clinic will tell you which pill to use, the day to start, how many days to take it, and the exact day to stop; this differs from normal contraceptive use. | Step 2: Take the tablet - Swallow one active tablet once daily at the same time each day, with or without food. | Step 3: Active pills only - If your pack has placebo (sugar) pills, your clinic usually wants you on the active hormone pills only; check whether to skip the placebo week. | Step 4: Stop on cue - Stop exactly on the day your clinic gives you. A withdrawal bleed often starts a few days later, and stimulation is timed from there. | ⚠ Missed dose - If less than 24 hours late, take it as soon as you remember and carry on. If more than 24 hours late or you miss more than one, take the most recent missed pill and call your clinic. | ⚠ When to call - Seek urgent care for calf pain or swelling, chest pain, sudden shortness of breath, coughing up blood, a severe headache, one-sided weakness or numbness, or sudden vision or speech changes.",
        "sideEffects": [
          "Nausea",
          "Breast tenderness",
          "Spotting or breakthrough bleeding",
          "Headache",
          "Mood changes",
          "Bloating and fluid retention",
          "Reduced libido",
          "Small increased risk of blood clots (uncommon; higher if you smoke or are over 35)"
        ],
        "storage": "Store at room temperature, around 20 to 25°C (68 to 77°F). Keep in the original packaging, away from heat and moisture, and out of reach of children.",
        "forWhom": "her",
        "aliases": [
          "the pill",
          "combined pill",
          "combined oral contraceptive",
          "OCP",
          "Yaz",
          "Yasmin",
          "Beyaz",
          "Microgynon",
          "Rigevidon",
          "Levlen",
          "Logynon",
          "Trinordiol",
          "Marvelon",
          "Mercilon",
          "Gedarel",
          "Femodene",
          "Femodette",
          "Millinette",
          "Katya",
          "Cilest",
          "Cilique",
          "Lucette",
          "Eloine",
          "Brevinor",
          "Norimin",
          "Qlaira",
          "Natazia",
          "Zoely",
          "Diane-35",
          "Dianette",
          "Loestrin",
          "Lo Loestrin Fe",
          "Junel",
          "Microgestin",
          "Ortho Tri-Cyclen",
          "Ortho-Cyclen",
          "Ortho-Novum",
          "Sprintec",
          "Tri-Sprintec",
          "Mononessa",
          "Alesse",
          "Aviane",
          "Lessina",
          "Levora",
          "Portia",
          "Nordette",
          "Apri",
          "Reclipsen",
          "Mircette",
          "Kariva",
          "Lutera",
          "Min-Ovral",
          "Linessa",
          "Trifeme",
          "Estelle"
        ],
        "availability": [
          {
            "name": "Microgynon",
            "manufacturer": "Bayer",
            "countries": ["GB", "EU", "AU", "NZ", "ZA"]
          },
          {
            "name": "Rigevidon",
            "manufacturer": "Gedeon Richter",
            "countries": ["GB", "EU"]
          },
          {
            "name": "Marvelon",
            "manufacturer": "Organon",
            "countries": ["GB", "EU", "CA", "AU"]
          },
          {
            "name": "Mercilon",
            "manufacturer": "Organon",
            "countries": ["GB", "EU"]
          },
          {
            "name": "Yasmin",
            "manufacturer": "Bayer",
            "countries": ["US", "GB", "EU", "CA", "AU"]
          },
          {
            "name": "Yaz",
            "manufacturer": "Bayer",
            "countries": ["US", "GB", "EU", "CA", "AU"]
          },
          {
            "name": "Loestrin",
            "manufacturer": "Galen / Mayne",
            "countries": ["US", "GB", "CA"]
          },
          {
            "name": "Ortho Tri-Cyclen",
            "manufacturer": "Janssen",
            "countries": ["US", "CA"]
          },
          {
            "name": "Alesse",
            "manufacturer": "Pfizer",
            "countries": ["US", "CA"]
          },
          {
            "name": "Levlen",
            "manufacturer": "Bayer",
            "countries": ["AU", "NZ"]
          },
          {
            "name": "Qlaira",
            "manufacturer": "Bayer",
            "countries": ["GB", "EU", "AU"]
          },
          {
            "name": "Diane-35",
            "manufacturer": "Bayer",
            "countries": ["GB", "EU", "CA", "AU"]
          }
        ],
        "frBody": {
          "genericName": "Contraceptif oral combiné (éthinylestradiol + progestatif)",
          "drugClass": "Contraceptif hormonal combiné (œstrogène + progestatif)",
          "purpose": "La pilule combinée contient un œstrogène (généralement l'éthinylestradiol) et un progestatif. Ce n'est pas un médicament de fertilité en soi, mais en FIV elle sert souvent de prétraitement avant un cycle de stimulation avec antagoniste. En mettant temporairement les ovaires au repos, elle permet au centre de planifier précisément le début de la stimulation, ce qui aide à programmer la ponction et le laboratoire. Elle peut aussi aider les petits follicules à se développer plus régulièrement. C'est une classe de médicaments et non une seule marque ; votre centre peut prescrire l'une des nombreuses pilules combinées disponibles.",
          "dosageRanges": "Habituellement un comprimé actif par voie orale une fois par jour pendant environ 2 à 4 semaines avant de commencer la stimulation, puis arrêt le jour indiqué par votre centre (souvent 3 à 5 jours avant le début des injections). La pilule, la durée et le jour d'arrêt exacts sont fixés par votre centre ; suivez ses consignes plutôt que le schéma habituel de la plaquette.",
          "howToTake": "Étape 1 : Confirmer le plan - Votre centre vous indiquera quelle pilule utiliser, le jour de début, le nombre de jours et le jour exact d'arrêt ; cela diffère de l'usage contraceptif habituel. | Étape 2 : Prendre le comprimé - Avalez un comprimé actif une fois par jour à la même heure, avec ou sans nourriture. | Étape 3 : Comprimés actifs uniquement - Si la plaquette contient des comprimés placebo, le centre souhaite généralement que vous ne preniez que les comprimés actifs ; demandez s'il faut sauter la semaine de placebo. | Étape 4 : Arrêter au signal - Arrêtez exactement le jour indiqué. Un saignement de privation commence souvent quelques jours après, et la stimulation est programmée à partir de là. | ⚠ Dose oubliée - Si moins de 24 heures de retard, prenez-la dès que possible et continuez. Si plus de 24 heures ou plusieurs oublis, prenez le dernier comprimé oublié et appelez votre centre. | ⚠ Quand appeler - Consultez en urgence en cas de douleur ou gonflement du mollet, douleur thoracique, essoufflement soudain, crachats de sang, maux de tête sévères, faiblesse ou engourdissement d'un côté, ou troubles soudains de la vision ou de la parole.",
          "sideEffects": [
            "Nausées",
            "Sensibilité des seins",
            "Pertes ou saignements entre les règles",
            "Maux de tête",
            "Changements d'humeur",
            "Ballonnements et rétention d'eau",
            "Baisse de la libido",
            "Léger risque accru de caillots sanguins (peu fréquent ; plus élevé en cas de tabagisme ou après 35 ans)"
          ],
          "storage": "Conserver à température ambiante, autour de 20 à 25°C (68 à 77°F). Garder dans l'emballage d'origine, à l'abri de la chaleur et de l'humidité, et hors de portée des enfants."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
